"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMfaVerify = AuthMfaVerify;
exports.AuthReauthenticate = AuthReauthenticate;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const Helper_1 = require("../Helper");
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const GoogleSignIn_1 = require("../shared/GoogleSignIn");
const Button_1 = __importDefault(require("../components/Button"));
const PasswordInput_1 = __importDefault(require("../components/PasswordInput"));
const Recaptcha_1 = __importDefault(require("../components/Recaptcha"));
const Google_svg_1 = __importDefault(require("../images/Google.svg"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        messageOuter: {
            marginTop: size != 'sm' ? 12 : 12,
            marginBottom: size != 'sm' ? -8 : 0,
        },
        message: {
            color: THEME.Text,
            fontSize: 14,
            fontWeight: '500',
            textAlign: 'center'
        },
        termsMessage: {
            color: `${THEME.AlwaysWhite}99`,
            fontSize: 12,
            textAlign: 'left'
        },
        text: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 18 : 16
        },
        textInput: {
            height: (Helper_1.Helper.isPlatformWeb ? 50 : null)
        }
    });
};
function AuthMfaVerify(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const refVerifyCode = react_1.default.useRef(null);
    const refRecaptcha = react_1.default.useRef(null);
    const [methods, setMethods] = react_1.default.useState([]);
    const [verifyCode, setVerifyCode] = react_1.default.useState('');
    const [verifyAttempt, setVerifyAttempt] = react_1.default.useState(null);
    const [sending, setSending] = react_1.default.useState(null);
    const [verifying, setVerifying] = react_1.default.useState(false);
    const [codeSent, setCodeSent] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const [mfaFactor, setMfaFactor] = react_1.default.useState('');
    const [trustDevice, setTrustDevice] = react_1.default.useState(false);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    react_1.default.useEffect(() => {
        setMethods(props.resolver?.hints);
        if (props.resolver?.hints?.length == 1 && props.resolver?.hints[0]?.factorId == 'phone') {
            handleSendCode(0, 'phone');
        }
        else if (props.resolver?.hints?.length == 1 && props.resolver?.hints[0]?.factorId == 'totp') {
            handleEnterCode(props.resolver?.hints[0]?.uid, 'totp');
        }
    }, []);
    react_1.default.useEffect(() => {
        if (!sending && verifyAttempt) {
            // Timeout is a workaround for React Native Paper.
            setTimeout(() => refVerifyCode.current?.focus(), 100);
        }
    }, [sending, verifyAttempt]);
    const handleSendCode = (index, factorId) => {
        setCodeSent(true);
        setSending(index);
        setMessage(null);
        Authentication_1.default.MfaVerifySendCode(props.resolver, index, refRecaptcha.current).then((id) => {
            setVerifyAttempt(id);
            setMfaFactor(factorId);
        }).catch((error) => {
            setMessage(t('login:messages.mfaCodeFailed'));
        }).finally(() => {
            setSending(null);
        });
    };
    const handleEnterCode = (index, factorId) => {
        setVerifyAttempt(index);
        setVerifying(false);
        setSending(null);
        setMfaFactor(factorId);
    };
    const handleVerify = () => {
        if (verifyCode?.length < 6 || verifyAttempt == null) {
            setMessage('Error');
        }
        else {
            setVerifying(true);
            ((() => {
                if (mfaFactor == 'totp')
                    return Authentication_1.default.MfaVerifyTotpResolveCode;
                else
                    return Authentication_1.default.MfaVerifyResolveCode;
            })())(props.resolver, verifyAttempt, verifyCode).then((credential) => {
                if (trustDevice && props.allowTrustDevice) {
                    return props.onTrustDevice?.(credential?.user);
                }
            }).then(() => {
                props.onSuccess?.call();
            }).catch((error) => {
                switch (error?.code) {
                    case 'auth/invalid-verification-code':
                        setMessage(t('login:messages.mfaCodeInvalid'));
                        break;
                    default:
                        setMessage(t('login:messages.defaultErr'));
                        break;
                }
            }).finally(() => {
                setVerifying(false);
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: t('login:text.mfaToContinue') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: methods?.map((item, index) => (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', paddingVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Solid.MobileScreenButton, size: 22, style: { marginRight: 12, marginBottom: -1 } }), item.factorId == 'totp' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 18, fontWeight: '400' }, children: item.displayName }) }), methods?.length > 1 &&
                                    (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: sending != null || verifying, type: "outline", "aria-label": t('login:buttons.mfaEnterCode'), text: t('login:buttons.mfaEnterCode'), onPress: () => handleEnterCode(item.uid, item.factorId), style: { paddingHorizontal: 12 } })] })) || ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 18, fontWeight: '400' }, children: item.phoneNumber }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: sending != null || verifying, type: "outline", "aria-label": t('login:buttons.mfaSendCode'), text: sending == index ? t('login:buttons.mfaSending') : (codeSent ? t('login:buttons.mfaResendCode') : t('login:buttons.mfaSendCode')), onPress: () => handleSendCode(index, item.factorId), style: { paddingHorizontal: 12 } })] }))] }, item.uid)) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: STYLES.separator }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8, opacity: (verifyAttempt ? 1.0 : 0.4) }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: t('login:text.mfaEnterCode') }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { ref: refVerifyCode, label: t('login:labels.mfaVerificationCode'), "aria-label": t('login:labels.mfaVerificationCode'), disabled: sending != null || verifying || !verifyAttempt, value: verifyCode ?? '', style: styles.textInput, mode: "outlined", onChangeText: (v) => setVerifyCode(v), onSubmitEditing: handleVerify }), Helper_1.Helper.isPlatformWeb &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: (Helper_1.Helper.isPlatformWeb ? 'none' : null) }, children: (0, jsx_runtime_1.jsx)(Recaptcha_1.default, { ref: refRecaptcha, verificationInvisible: true }) })] }), props.allowTrustDevice &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 10, flexDirection: 'row' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { "aria-label": t('login:labels.trustDevice'), role: 'checkbox', onPress: () => setTrustDevice(!trustDevice), style: ({ pressed }) => [(pressed ? STYLES.pressedOpacity : null)], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: trustDevice ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square, color: THEME.Primary, size: 20, style: { marginHorizontal: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                        color: THEME.Text,
                                        fontSize: size != 'sm' ? 16 : 14,
                                    }, children: t('login:labels.trustDevice') })] }) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", "aria-label": t('common:buttons.cancel'), text: t('common:buttons.cancel'), extraPadding: 4, onPress: props.onCancel }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: sending != null || verifying || !verifyAttempt, "aria-label": t('common:buttons.continue'), text: t('common:buttons.continue'), extraPadding: 4, onPress: handleVerify }) })] }), message &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { height: 40, marginBottom: -80, marginTop: 40 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: styles.termsMessage, children: [t('login:text.recaptchaDisclose'), (0, jsx_runtime_1.jsx)(react_native_paper_1.Paragraph, { style: { fontSize: 12, color: THEME.AlwaysWhite, textDecorationLine: 'underline' }, onPress: () => react_native_1.Linking.openURL("https://policies.google.com/privacy"), children: t('login:text.privacyPolicy') }), t('login:text.and'), (0, jsx_runtime_1.jsx)(react_native_paper_1.Paragraph, { style: { fontSize: 12, color: THEME.AlwaysWhite, textDecorationLine: 'underline' }, onPress: () => react_native_1.Linking.openURL("https://policies.google.com/terms"), children: t('login:text.terms') }), t('login:text.apply')] }) })] }));
}
;
function AuthReauthenticate(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const refPassword = react_1.default.useRef(null);
    const [password, setPassword] = react_1.default.useState('');
    const [verifyResolver, setVerifyResolver] = react_1.default.useState(null);
    const [working, setWorking] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        // Timeout is a workaround for React Native Paper.
        let t = setTimeout(() => refPassword.current.focus(), 100);
        return () => clearTimeout(t);
    }, [message]);
    const handleLoginError = (error) => {
        switch (error?.code) {
            case 'auth/multi-factor-auth-required':
                let resolver = Authentication_1.default.MfaVerifyStart(error);
                setVerifyResolver(resolver);
                break;
            case 'auth/too-many-requests':
                setMessage(t('login:messages.accountLocked'));
                break;
            default:
                setMessage(t('login:messages.loginFail'));
                break;
        }
    };
    const handleReauth = () => {
        if (password?.length > 0) {
            setWorking(true);
            Authentication_1.default.Reauthenticate(password)
                .then(() => props.onSuccess())
                .catch((e) => handleLoginError(e))
                .finally(() => setWorking(false));
        }
    };
    const handleGoogle = () => {
        setWorking(true);
        let loginGoogle = GoogleSignIn_1.GoogleSignIn.SignIn();
        if (!Helper_1.Helper.isPlatformWeb) {
            // Google response will redirect to login page on web.
            // Handle response immediately for native.
            loginGoogle
                .then(() => props.onSuccess())
                .catch((e) => handleLoginError(e))
                .finally(() => setWorking(false));
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: verifyResolver
            &&
                (0, jsx_runtime_1.jsx)(AuthMfaVerify, { resolver: verifyResolver, onSuccess: () => props.onSuccess?.call(), onCancel: () => props.onCancel?.call() })
            ||
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 8, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: t('login:text.confirmPassword') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsx)(PasswordInput_1.default, { kind: "paper", inputRef: refPassword, label: t("login:labels.password"), value: password ?? "", style: styles.textInput, mode: "outlined", disabled: working, onChangeText: (v) => setPassword(v), onSubmitEditing: handleReauth, showCapsWarning: Helper_1.Helper.isPlatformWeb }) }), props.allowGoogle &&
                            (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (react_native_1.Platform.OS == 'android' && react_native_1.Platform.Version < 33) &&
                                    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})
                                    ||
                                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('login:buttons.google'), accessibilityHint: t('login:hints.google'), type: "solid", color: THEME.SmokeWhite, disabled: working, onPress: handleGoogle, children: [(0, jsx_runtime_1.jsx)(Google_svg_1.default, { height: 28, width: 28 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                            marginTop: -2,
                                                            color: THEME.SmokeWhiteText,
                                                            fontSize: 16
                                                        }, children: t('login:buttons.google') })] }) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", "aria-label": t('common:buttons.cancel'), text: t('common:buttons.cancel'), extraPadding: 4, onPress: props.onCancel }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working, "aria-label": t('common:buttons.continue'), text: t('common:buttons.continue'), extraPadding: 4, onPress: handleReauth }) })] }), message &&
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) })] }) }));
}
;
